import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolsContainer: {
      padding: '30px',
      textAlign: 'right',
      alignItems: 'center',
      borderBottom: `1.9px solid ${theme.oysterTheme.stone}`,
    },
    columnsButton: {
      color: theme.oysterTheme.extraGrey,
      fontSize: '1rem',
      fontWeight: 500,
    },
    groupBySelectContainer: {
      width: 250,
      textAlign: 'left',
      marginRight: '10px',
      marginLeft: 'auto',
    },
    label: {
      fontSize: '1rem',
      color: theme.oysterTheme.extraGrey,
      fontWeight: 500,
    },
  }),
);

export default useStyles;
